import { Plan, useI18n } from '@springbig/shared';
import { Box } from 'native-base';
import { Caption, H2 } from '~/shared/Typography';
import Button from '~/shared/Button';
import { useGeneralStyles } from '~/shared/styles';
import Confetti from '~/pages/subscriptions/components/Confetti';
import React from 'react';

type SubscribeSuccessScreenProps = {
    plan: Plan;
    onProceed: (destination: Destinations) => void;
};

export type Destinations = 'subscriptions' | 'offers';

const SubscribeSuccessScreen = ({ plan, onProceed }: SubscribeSuccessScreenProps) => {

    const gStyle = useGeneralStyles();
    const { t } = useI18n();

    return (
        <Box textAlign={'center'} px={4}>

            <Confetti />

            <H2>{ t('subscriptions.success.title', [plan.name]) }</H2>
            <Box my={10}>
                <Caption>{ t('subscriptions.success.description', [plan.name]) }</Caption>
                <Caption>{ t('subscriptions.success.description_two') }</Caption>
            </Box>

            <Box>
                { plan.has_offers &&
                    <Button
                        marginBottom={5}
                        bg={gStyle.button_background}
                        _text={{ color: gStyle.button_text }}
                        onPress={() => onProceed('offers')}
                    >
                        { t('subscriptions.success.view_offers_button') }
                    </Button>
                }
                <Button
                    bg={gStyle.button_background}
                    _text={{ color: gStyle.button_text }}
                    onPress={() => onProceed('subscriptions')}
                >
                    { t('subscriptions.back_button') }
                </Button>
            </Box>
        </Box>
    );
};

export default SubscribeSuccessScreen;
